import React from 'react';

import { StackView, Divider, Typography } from '@telus-uds/components-web';

import { useLocalizedStringsContext } from '../context/LocalizedStringsContext';
import { Container } from './components/form/css';
import Form from './components/form';

import DefectManagement from '../defectManagement';

const ReportAnIssue = () => {
  const {
    DEFECT_MANAGEMENT: { TITLE }
  } = useLocalizedStringsContext();

  return (
    <>
      <div className="container 85%">
        <Container>
          <StackView space={4}>
            <Typography heading="h2" variant={{ size: 'h2' }} block>{TITLE}</Typography>
            <Divider space={0} variant={{ inverse: true }} />
            <Form />
          </StackView>
        </Container>
      </div>
      <Divider space={6} variant={{ inverse: true }} />
      <DefectManagement />
    </>
  );
};

export default ReportAnIssue;
